import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  document: {
    flexWrap: 'nowrap',
    height: 56,
    display: 'flex',
    borderRadius: 8,
    width: '100%',
    alignItems: 'center',
    flexFlow: 'row wrap',
    justifyContent: 'space-between',
    paddingLeft: 16,
    paddingRight: 16,
    transition: 'background-color 100ms linear',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.default,
      '& .MuiChip-root': {
        backgroundColor: theme.palette.divider
      }
    }
  },
  url: {
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center'
  },
  popover: {
    pointerEvents: 'none'
  },
  paperPopover: {
    maxWidth: '250px',
    wordBreak: 'break-all'
  },
  adviceChip: {
    cursor: 'pointer'
  },
  title: {
    flexGrow: 1,
    width: 179,
    display: 'flex',
    alignItems: 'center'
  },
  advice: {
    flexGrow: 0,
    display: 'flex',
    alignItems: 'center',
    width: 109,
    justifyContent: 'flex-end'
  },
  fullWidth: {
    width: '95%'
  }
}))

export default useStyles
